function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllProductsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#57a4ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168 136v32h-16v48h-64v-48h-16v-32l32-16a16 16 0 0 0 32 0z",
    fill: "#000000",
    "data-original": "#57a4ff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 312v32h-16v48h-64v-48h-16v-32l32-16a16 16 0 0 0 32 0z",
    fill: "#000000",
    "data-original": "#57a4ff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 192h48v48h-48z",
    fill: "#000000",
    "data-original": "#57a4ff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 368h48v48h-48z",
    fill: "#000000",
    "data-original": "#57a4ff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.28 456-8.28 16v-16z",
    fill: "#000000",
    "data-original": "#57a4ff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 136v32h-16v48h-64v-48h-16v-32l32-16a16 16 0 0 0 32 0z",
    fill: "#000000",
    "data-original": "#57a4ff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 312v32h-16v48h-64v-48h-16v-32l32-16a16 16 0 0 0 32 0z",
    fill: "#000000",
    "data-original": "#57a4ff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 456h120v40h-120z",
    fill: "#000000",
    "data-original": "#57a4ff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464 36v28h-448v-28a19.994 19.994 0 0 1 20-20h408a19.994 19.994 0 0 1 20 20z",
    fill: "#000000",
    "data-original": "#57a4ff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 136v32h-16v48h-64v-48h-16v-32l32-16a16 16 0 0 0 32 0z",
    fill: "#000000",
    "data-original": "#57a4ff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 312v32h-16v48h-64v-48h-16v-32l32-16a16 16 0 0 0 32 0z",
    fill: "#000000",
    "data-original": "#57a4ff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 192h48v48h-48z",
    fill: "#000000",
    "data-original": "#57a4ff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 368h48v48h-48z",
    fill: "#000000",
    "data-original": "#57a4ff",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#004fac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m496.97 287.01a24.045 24.045 0 0 0 -24.97-5.64v-9.37c0-.23-.01-.45-.02-.68.01-.1.02-.21.02-.32v-235a28.031 28.031 0 0 0 -28-28h-408a28.031 28.031 0 0 0 -28 28v416a28.031 28.031 0 0 0 28 28h316v16a8 8 0 0 0 8 8h120a8 8 0 0 0 8-8v-40a8 8 0 0 0 -8-8v-23.08l23.12-45.28a7.977 7.977 0 0 0 .88-3.64v-72a23.924 23.924 0 0 0 -7.03-16.99zm-472.97-251.01a12.01 12.01 0 0 1 12-12h408a12.01 12.01 0 0 1 12 12v20h-432zm336 412a8 8 0 0 0 -8 8v8h-316a12.01 12.01 0 0 1 -12-12v-380h432v177.36a24.123 24.123 0 0 0 -16.83.32 23.995 23.995 0 0 0 -23.17-17.68 23.836 23.836 0 0 0 -8 1.37v-17.37a24 24 0 0 0 -48 0v65.36a24.03 24.03 0 0 0 -32 22.64v72a7.945 7.945 0 0 0 1.39 4.5l30.61 44.96zm112 40h-104v-24h104zm16-113.92-23.12 45.28a7.977 7.977 0 0 0 -.88 3.64v25h-88v-25a7.945 7.945 0 0 0 -1.39-4.5l-30.61-44.96v-69.54a8 8 0 1 1 16 0v40a8 8 0 0 0 16 0v-128a8 8 0 1 1 16 0v96a8 8 0 0 0 16 0v-56a8 8 0 1 1 16 0v56a8 8 0 0 0 16 0v-40a8 8 0 1 1 16 0v40a8 8 0 0 0 16 0v-8a8 8 0 1 1 16 0z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 48h8a8 8 0 0 0 0-16h-8a8 8 0 0 0 0 16z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 48h8a8 8 0 0 0 0-16h-8a8 8 0 0 0 0 16z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104 48h8a8 8 0 0 0 0-16h-8a8 8 0 0 0 0 16z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 88h-144a8 8 0 0 0 -8 8v144a8 8 0 0 0 8 8h144a8 8 0 0 0 8-8v-144a8 8 0 0 0 -8-8zm-8 144h-128v-128h128z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.58 128.84-32-16a8 8 0 0 0 -11.58 7.16 8 8 0 0 1 -16 0 8 8 0 0 0 -11.58-7.16l-32 16a8.011 8.011 0 0 0 -4.42 7.16v32a8 8 0 0 0 8 8h8v40a8 8 0 0 0 8 8h64a8 8 0 0 0 8-8v-40h8a8 8 0 0 0 8-8v-32a8.011 8.011 0 0 0 -4.42-7.16zm-11.58 31.16h-8a8 8 0 0 0 -8 8v40h-48v-40a8 8 0 0 0 -8-8h-8v-19.06l18.93-9.46a23.989 23.989 0 0 0 42.14 0l18.93 9.46z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 352h8v40a8 8 0 0 0 8 8h64a8 8 0 0 0 8-8v-40h8a8 8 0 0 0 8-8v-32a8 8 0 0 0 -4.422-7.155l-32-16a8 8 0 0 0 -11.578 7.155 8 8 0 0 1 -16 0 8 8 0 0 0 -11.578-7.155l-32 16a8 8 0 0 0 -4.422 7.155v32a8 8 0 0 0 8 8zm8-35.056 18.928-9.464a23.993 23.993 0 0 0 42.144 0l18.928 9.464v19.056h-8a8 8 0 0 0 -8 8v40h-48v-40a8 8 0 0 0 -8-8h-8z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 264h-144a8 8 0 0 0 -8 8v144a8 8 0 0 0 8 8h144a8 8 0 0 0 8-8v-144a8 8 0 0 0 -8-8zm-8 144h-128v-128h128z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 104h152a8 8 0 0 0 0-16h-152a8 8 0 0 0 0 16z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 128h152a8 8 0 0 0 0-16h-152a8 8 0 0 0 0 16z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 152h152a8 8 0 0 0 0-16h-152a8 8 0 0 0 0 16z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312 160h-88a8 8 0 0 0 0 16h88a8 8 0 0 0 0-16z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344 160h-8a8 8 0 0 0 0 16h8a8 8 0 0 0 0-16z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 264h-80a8 8 0 0 0 0 16h80a8 8 0 0 0 0-16z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 288h-80a8 8 0 0 0 0 16h80a8 8 0 0 0 0-16z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 312h-80a8 8 0 0 0 0 16h80a8 8 0 0 0 0-16z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 352h24a8 8 0 0 0 0-16h-24a8 8 0 0 0 0 16z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280 336h-8a8 8 0 0 0 0 16h8a8 8 0 0 0 0-16z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 248h48a8 8 0 0 0 8-8v-48a8 8 0 0 0 -8-8h-48a8 8 0 0 0 -8 8v48a8 8 0 0 0 8 8zm8-48h32v32h-32z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272 360h-48a8 8 0 0 0 -8 8v48a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-48a8 8 0 0 0 -8-8zm-8 48h-32v-32h32z",
    fill: "#000000",
    "data-original": "#004fac",
    style: {},
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllProductsIcon);
export default __webpack_public_path__ + "static/media/all-products-icon.9c6881c880bcaf57b392428b929bdc3f.svg";
export { ForwardRef as ReactComponent };